import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Investigations.css';

const Investigations = () => {
  return (
    <>
      <Helmet>
        <title>Investigations - Investigative Journalism & Exposés | Redbox Global</title>
        <meta name="description" content="Redbox Global Investigations delivers hard-hitting investigative journalism exposing corruption, fraud, and corporate malfeasance. In-depth reporting that holds power accountable." />
        <meta name="keywords" content="investigative journalism, business investigations, corporate fraud, corruption exposé, financial crime, investigative reporting, whistleblower stories, accountability journalism" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/investigations" />
        <meta property="og:title" content="Investigations - Investigative Journalism & Exposés | Redbox Global" />
        <meta property="og:description" content="Hard-hitting investigative journalism exposing corruption, fraud, and corporate malfeasance." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/investigations" />
        <meta name="twitter:title" content="Investigations - Investigative Journalism & Exposés | Redbox Global" />
        <meta name="twitter:description" content="Hard-hitting investigative journalism exposing corruption, fraud, and corporate malfeasance." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/investigations" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Investigations</h1>
          <p className="page-subtitle">Uncovering the truth behind business, finance, and power</p>
        </div>
        
        <div className="page-content">
          <a href="/article/offshore-tax-havens-exposed" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=600&fit=crop" alt="Investigation" />
              </div>
              <div className="featured-content">
               
                <h2>The Hidden Billions: Inside the Offshore Tax Network</h2>
                <p>A six-month investigation reveals how Fortune 500 companies and billionaires use a complex web of shell companies, offshore accounts, and legal loopholes to avoid $300 billion in taxes annually. Based on leaked documents from 12 tax havens and interviews with whistleblowers, this exposé traces the money trail from Delaware to the Cayman Islands and reveals the politicians who profit from keeping the system intact.</p>
                <span className="article-meta">30 min read • Investigation Team • 6 Months Research</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/pharmaceutical-pricing-scandal" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&h=400&fit=crop" alt="Pharmaceutical investigation" />
                </div>
                <div className="article-content">
                 
                  <h2>Big Pharma's Hidden Price-Fixing Scheme</h2>
                  <p>Internal documents expose coordinated efforts to inflate drug prices by over 400%.</p>
                  <span className="article-meta">25 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/crypto-exchange-collapse" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&h=400&fit=crop" alt="Crypto investigation" />
                </div>
                <div className="article-content">
                  
                  <h2>How a $10 Billion Crypto Exchange Vanished</h2>
                  <p>Tracking the missing funds and executives behind the year's biggest financial fraud.</p>
                  <span className="article-meta">28 min read</span>
                </div>
              </article>
            </a>

            <a href="/article/labor-exploitation-investigation" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=600&h=400&fit=crop" alt="Labor investigation" />
                </div>
                <div className="article-content">
                 
                  <h2>The Supply Chain's Dirty Secret</h2>
                  <p>Major retailers face reckoning after investigation uncovers forced labor in factories.</p>
                  <span className="article-meta">35 min read</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Investigations;
